import React from 'react';
import { usePremiumCoupons } from '../hooks/usePremiumCoupons';
import PremiumCouponPoster from '../components/PremiumCouponPoster';

const PremiumCoupons = () => {
  const { premiumCoupons, loading, error, refreshing, lastUpdated } = usePremiumCoupons();
  const daytimeCoupons = premiumCoupons.filter((coupon) => String(coupon.couponType || '').startsWith('daytime_'));
  const eveningCoupons = premiumCoupons.filter((coupon) => String(coupon.couponType || '').startsWith('evening_'));
  const editorCoupons = premiumCoupons.filter((coupon) => String(coupon.couponType || '').startsWith('editor_'));
  const systemCouponCount = daytimeCoupons.length + eveningCoupons.length;
  const showQualityWarning = systemCouponCount < 4;

  if (loading) return <div className="loading">Premium kuponlar yukleniyor...</div>;

  if (error) {
    return (
      <div className="page analysis-page premium-analysis-scope">
        <section className="content-panel">
          <p className="analysis-summary">Premium kuponlar su anda hazirlaniyor.</p>
        </section>
      </div>
    );
  }

  return (
    <div className="page analysis-page premium-analysis-scope">
      <section className="hero-panel compact premium-coupon-hero">
        <div className="hero-copy">
          <span className="hero-badge premium-hero-badge">
            <img src="/premium-crown.svg" alt="Premium tac" />
            <span>PREMIUM KUPON</span>
          </span>
          <h1 className="live-hero-title">GUNDUZ VE AKSAM PREMIUM KUPONLARI</h1>
          <p>Mat siyah premium kupon panelinde kalite seviyesi, ortalama edge ve AI yorumu ile gunluk paketleri okuyun.</p>
          {lastUpdated ? <p className="analysis-cache-note">Son guncelleme: {new Date(lastUpdated).toLocaleString('tr-TR')}</p> : null}
        </div>
      </section>

      {refreshing && systemCouponCount === 0 ? (
        <section className="content-panel">
          <div className="premium-empty-card">Bugunun premium kuponlari hazirlaniyor.</div>
        </section>
      ) : null}

      {!refreshing && premiumCoupons.length === 0 ? (
        <section className="content-panel">
          <div className="premium-empty-card">Bugunun premium kuponlari hazirlaniyor.</div>
        </section>
      ) : null}

      {showQualityWarning ? (
        <section className="content-panel">
          <p className="analysis-summary">
            Bugun kupon kalitesi temkinli seviyede. Kuponlar yine yayinlandi ancak risk notlari dikkatle okunmali.
          </p>
        </section>
      ) : null}

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Gunduz Kuponlari</h2>
            <p>Gunduz seansinda one cikan 2 ve 3 maclik premium paketler.</p>
          </div>
        </div>
        <div className="analysis-grid premium-coupon-grid">
          {daytimeCoupons.length ? daytimeCoupons.map((coupon) => (
            <PremiumCouponPoster key={`${coupon.couponDate}-${coupon.couponType}`} coupon={coupon} />
          )) : <div className="premium-empty-card">Premium kuponlar hazirlaniyor.</div>}
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Aksam Kuponlari</h2>
            <p>Aksam seansinda yayinlanan premium kupon paketleri.</p>
          </div>
        </div>
        <div className="analysis-grid premium-coupon-grid">
          {eveningCoupons.length ? eveningCoupons.map((coupon) => (
            <PremiumCouponPoster key={`${coupon.couponDate}-${coupon.couponType}`} coupon={coupon} />
          )) : <div className="premium-empty-card">Premium kuponlar hazirlaniyor.</div>}
        </div>
      </section>

      <section className="content-panel">
        <div className="section-heading">
          <div>
            <h2>Editor Kuponlari</h2>
            <p>Kontrollu editor secimleri bu alanda ayri tutulur.</p>
          </div>
        </div>
        <div className="analysis-grid premium-coupon-grid">
          {editorCoupons.length ? editorCoupons.map((coupon) => (
            <PremiumCouponPoster key={`${coupon.couponDate}-${coupon.couponType}`} coupon={coupon} />
          )) : <div className="premium-empty-card">Editor kuponu henuz olusturulmadi.</div>}
        </div>
      </section>
    </div>
  );
};

export default PremiumCoupons;
